import styled from 'styled-components';
import { black } from '@styles/colors';
import { multiplePixel } from '@styles/utils';
import { Paragraph } from '@components/Typos/Typos.s';

export const Wrapper = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  position: relative;
`;

export const FormWrapper = styled.form`
  position: absolute;
  ${multiplePixel(0, 'left', 'right', 'top', 'bottom')}
  overflow: hidden;
  flex: 1;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: space-between;
  transition-duration: .3s;
`;

export const QuizDoneWrapper = FormWrapper.withComponent('div');

export const FormHeader = styled.h3`
  font-family: 'Avenir';
  font-size: 1.1rem;
  line-height: 2rem;
  margin: 0.5rem;
  margin-top: 1rem;
  font-weight: normal;
  text-align: center;
  color: ${black};
  b {
    font-weight: 900;
  }
`;

export const FormContentWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 500%;
  align-items: stretch;
  flex-direction: row;
  justify-content: space-between;
  transition-duration: .3s;
`;

export const FormContentPage = styled.section`
  flex: 1;
  padding: 1rem 2rem;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
`;

export const FormSectionName = styled.h4`
  font-family: 'Avenir';
  font-weight: 600;
  font-size: 1rem;
  color: ${black};
  padding: 0 1rem;
  margin-bottom: 1rem;
`;

export const FormInput = styled.input`
  background: white;
  border: 1px solid #E8E8E8;
  font-family: 'Avenir';
  font-size: 0.8rem;
  color: #919191;
  padding: 0.6rem;
  margin: 0;
  margin-bottom: 1rem;
`;

export const SubText = styled.p`
  font-family: 'Avenir';
  font-size: 0.7rem;
  color: #B4B4B4;
  font-style: italic;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
  margin-top: -0.4rem;
  line-height: 0.9rem;
`;

export const DoneIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
  margin-top: 4rem;
`;

export const DoneText = styled.p`
  font-family: 'Avenir';
  font-size: 2rem;
  color: #6744C6;
  letter-spacing: 0.5px;
  text-align: center;
`;

export const DoneParagraphWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const DoneParagraph = Paragraph.extend`
  padding: 1rem 2rem;
  line-height: 2;
  text-align: center;
`;

export const FormControlsWrapper = styled.div`
  display: flex;
  padding: 0 0.5rem;
`;

type FormButtonProps = {
  disabled?: boolean;
};

export const FormTextarea = FormInput.withComponent('textarea').extend`
  flex: 1;
`;

export const AddPhotoButton = styled.button.attrs({
  type: 'button'
})`
  border: 1px solid #838383;
  font-family: 'Avenir';
  font-size: 1rem;
  color: #6E6E6E;
  padding: 0.7rem 1rem;
  margin: 0.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
  background: white;
`;

export const FormButton = styled.button.attrs({
  type: 'button'
})`
  background: ${(props: FormButtonProps) => props.disabled ? '#C6C6C6' : '#6744C6'};
  font-family: 'Avenir';
  transition-duration: .3s;
  font-weight: 600;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0.42px;
  box-shadow: 0 4px 0 ${(props: FormButtonProps) => props.disabled ? '#AAAAAA' : '#422494'};;
  text-transform: uppercase;
  border: none;
  padding: 0.7rem 1rem;
  font-size: 1.1rem;
  letter-spacing: 2px;
  margin: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  cursor: pointer;
  flex: 1;
`;



// WEBPACK FOOTER //
// src/app/src/components/ProForm/ProForm.s.ts